import sanitizeHtml from "sanitize-html-react";

const settingsSlider = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Only show one slide at a time
    slidesToScroll: 1,
    arrows: false,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Set the speed to 5 seconds
};

function getSentenceString(text) {
    var sentenceText = sanitizeHtml(text, {
        allowedTags: [],
        allowedAttributes: {
            'a': ['href'],

        }
    });
    return sentenceText;
}
const sentenceCount = (sentenceText) => {
    const sentences = sentenceText.match(/[^\.!\?]+[\.!\?]+/g);
    return sentences ? sentences.length : 0;
}

export { settingsSlider, getSentenceString, sentenceCount }